import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import OurWork from "../pages/our-work/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/nase-prace",
    element: <OurWork />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
